import { useEffect, useRef, useState } from "react";
import { EXAMPLE_PROMPTS } from "./bookSetupDefaults";

/**
 * Type / pause / delete rotating examples rendered as a non-interactive overlay.
 * Never writes into the textarea value.
 */
export function useAnimatedPrompt({ enabled, reducedMotion }) {
  const [text, setText] = useState("");
  const exampleIndex = useRef(0);
  const charIndex = useRef(0);
  const deleting = useRef(false);
  const timer = useRef(null);

  useEffect(() => {
    window.clearTimeout(timer.current);

    if (!enabled) {
      setText("");
      return undefined;
    }

    if (reducedMotion) {
      setText(EXAMPLE_PROMPTS[0]);
      return undefined;
    }

    const tick = () => {
      const current = EXAMPLE_PROMPTS[exampleIndex.current];
      if (!deleting.current) {
        charIndex.current += 1;
        setText(current.slice(0, charIndex.current));
        if (charIndex.current >= current.length) {
          deleting.current = true;
          timer.current = window.setTimeout(tick, 1900);
          return;
        }
        timer.current = window.setTimeout(tick, 38);
        return;
      }
      charIndex.current -= 1;
      setText(current.slice(0, charIndex.current));
      if (charIndex.current <= 0) {
        deleting.current = false;
        exampleIndex.current = (exampleIndex.current + 1) % EXAMPLE_PROMPTS.length;
        timer.current = window.setTimeout(tick, 420);
        return;
      }
      timer.current = window.setTimeout(tick, 20);
    };

    tick();
    return () => window.clearTimeout(timer.current);
  }, [enabled, reducedMotion]);

  return text;
}
